import {
  CreateAdhocWorkflowStepModel,
  DataEntityPresenterModel,
  DataEntityTypeEnum,
  DataEntryPresenterModel,
  EntityFilterModel,
  FieldPresenterModel,
} from '@osos/shared/types';
// tslint:disable-next-line: no-namespace
export namespace EntityActions {
  export class FetchEntities {
    static readonly type = '[Entity] Fetch Entities';
    constructor(
      public filter?: EntityFilterModel,
      public skip?: number,
      public limit?: number,
      public searchTerm?: string,
      public moduleId?: string,
    ) {}
  }

  /**
   * fetch entities then you can read them from transitoryEntities selector.
   * here selectOnce or selectSnapshot must be used, don't use any other selection methods
   */
  export class TransitoryFetchEntities {
    static readonly type = '[Entity] TransitoryFetch Entities';
    constructor(
      public payload: {
        filter?: EntityFilterModel;
        skip?: number;
        limit?: number;
        moduleId?: string;
        searchTerm?: string;
        entityIds?: string[];
        excludedIds?: string[];
        isEntityPublic?: boolean;
        getFullEntityDetails?: boolean;
      },
    ) {}
  }

  export class TransitoryFetchEntitiesWithMainPhone {
    static readonly type = '[Entity] TransitoryFetch Entities With Main Phone';
  }

  export class FetchEntity {
    static readonly type = '[Entity] Fetch Entity';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public viewId?: string,
    ) {}
  }

  export class SelectEntity {
    static readonly type = '[Entity] Select Entity';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public payload: {
        entityId: string;
        resolveEntryBreadcrumbTokens?: boolean;
        preservedEntries?: string[];
        clearCachedEntries?: boolean;
      },
    ) {}
  }
  export class UpdateEntitySelectedEntries {
    static readonly type = '[Entity] Update Selected Entity Selected Entries';
    constructor(
      public payload: {
        selectedEntries: DataEntryPresenterModel[];
      },
    ) {}
  }
  export class CreateEntity {
    static readonly type = '[Entity] Create Entity';
    constructor(public payload: DataEntityPresenterModel) {}
  }

  export class UpdateEntity {
    static readonly type = '[Entity] Update Entity';
    constructor(public payload: DataEntityPresenterModel) {}
  }

  export class ArchiveEntity {
    static readonly type = '[Entity] Archive Entity';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
    ) {}
  }

  export class ExecuteWorkflowAction {
    static readonly type = '[Entity] Execute Workflow Action';
    constructor(
      public entity: string,
      public entityType: DataEntityTypeEnum,
      public workflowId: string,
      public entry: string,
      public actionId: string,
      public notes: string,
      public viewId?: string,
    ) {}
  }
  export class BulkExecuteWorkflowAction {
    static readonly type = '[Entity] Bulk Execute Workflow Action';
    constructor(
      public entity: string,
      public workflowId: string,
      public entryIds: string[],
      public actionId: string,
      public notes: string,
    ) {}
  }

  export class ReturnToPreviousStep {
    static readonly type = '[Entity] Return to previous step';
    constructor(
      public entity: string,
      public workflowId: string,
      public entry: string,
      public step: string,
      public note: string,
      public viewId?: string,
    ) {}
  }

  export class MoveToStep {
    static readonly type = '[Entity] Move to later step';
    constructor(
      public entity: string,
      public workflowId: string,
      public entry: string,
      public step: string,
      public note: string,
      public viewId?: string,
    ) {}
  }

  export class CancelWorkflow {
    static readonly type = '[Entity] Cancel workflow';
    constructor(
      public entity: string,
      public workflowId: string,
      public entry: string,
      public note: string,
      public viewId?: string,
    ) {}
  }

  export class ResetWorkflow {
    static readonly type = '[Entity] Reset workflow';
    constructor(
      public entity: string,
      public workflowId: string,
      public entry: string,
      public note: string,
      public viewId?: string,
    ) {}
  }

  export class EntitiesCount {
    static readonly type = '[Entity] Entities Count';
    constructor(
      public moduleId?: string,
      public dataCollectionId?: string,
    ) {}
  }

  export class CreateAdhocStep {
    static readonly type = '[Entry] Create Adhoc step';
    constructor(
      public entity: DataEntityPresenterModel,
      public workflowId: string,
      public entry: string,
      public body: CreateAdhocWorkflowStepModel,
      public viewId?: string,
    ) {}
  }

  export class FetchSystemFields {
    static readonly type = '[Entity] Fetch System Fields';
  }
  export class FetchEntityVersionChanges {
    static readonly type = '[Entity] Fetch Entity Version Changes';
    constructor(
      public entity: string,
      public version: number,
    ) {}
  }

  export class SetRelationFieldsMapping {
    static readonly type = '[Data Query] Set Query Fields Mapping';
    constructor(
      public payload: {
        fieldName: string;
        field: FieldPresenterModel;
      }[],
    ) {}
  }

  export class FetchReactionsEntries {
    static readonly type = '[Entity Reactions] Fetch Reactions Entries';
    constructor(public entityId: string) {}
  }
}
